import { render, staticRenderFns } from "./ProcessNewCollection.vue?vue&type=template&id=f6626038&"
import script from "./ProcessNewCollection.vue?vue&type=script&lang=js&"
export * from "./ProcessNewCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports